<template>
  <div class="sso-login">
    <div class="loading-box" v-if="loading">
      <div class="loading-spinner"></div>
      <div class="loading-text">正在进行单点登录...</div>
    </div>
    <div class="error-box" v-if="errorMsg">
      <div class="error-icon">!</div>
      <div class="error-title">暂无权限</div>
      <div class="error-text">请联系管理员</div>
    </div>
  </div>
</template>

<script>
import { Loading, Message } from 'element-ui';

export default {
  name: 'SsoLogin',
  data() {
    return {
      loading: true,
      errorMsg: '',
    };
  },
  methods: {
    // 获取URL参数中的authCode
    getAuthCode() {
      const hash = window.location.hash;
      const queryString = hash.split('?')[1] || '';
      const urlParams = new URLSearchParams(queryString);
      return urlParams.get('authCode') || urlParams.get('code');
    },

    // 单点登录主流程
    ssoLogin() {
      const authCode = this.getAuthCode();

      if (!authCode) {
        this.loading = false;
        this.errorMsg = '缺少授权码';
        return;
      }

      // 使用auth.js中的ssoLogin方法完成登录（只需要authCode）
      this.$auth.ssoLogin(authCode).catch(() => {
        // 捕获错误后，阻止auth.js的自动跳转逻辑
        // 手动设置isLogin为false，并确保不触发watch
        this.$auth.isLogin = false;
        this.loading = false;
        this.errorMsg = '登录失败';

        // 强制阻止路由跳转 - 清除可能的定时器
        const currentRoute = this.$route.fullPath;
        if (currentRoute.indexOf('sso-login') === -1) {
          // 如果已经跳走了，跳回来
          this.$router.replace('/sso-login?authCode=' + authCode);
        }
      });
    },
  },
  mounted() {
    let loading = Loading.service({});
    setTimeout(() => {
      loading.close();
    }, 500);

    this.ssoLogin();
  },
};
</script>

<style lang="less" scoped>
.sso-login {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);

  .loading-box {
    text-align: center;
    color: #fff;

    .loading-spinner {
      width: 50px;
      height: 50px;
      border: 4px solid rgba(255, 255, 255, 0.3);
      border-top-color: #fff;
      border-radius: 50%;
      animation: spin 1s linear infinite;
      margin: 0 auto 20px;
    }

    .loading-text {
      font-size: 18px;
    }
  }

  .error-box {
    text-align: center;
    background: rgba(255, 255, 255, 0.95);
    padding: 50px 60px;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    max-width: 500px;

    .error-icon {
      width: 64px;
      height: 64px;
      background: #f56c6c;
      color: #fff;
      border-radius: 50%;
      font-size: 32px;
      font-weight: bold;
      line-height: 64px;
      margin: 0 auto 20px;
    }

    .error-title {
      font-size: 24px;
      font-weight: bold;
      color: #303133;
      margin-bottom: 12px;
    }

    .error-text {
      font-size: 16px;
      color: #909399;
      line-height: 1.6;
    }
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
